module.exports = __webpack_public_path__ + "static/Corn1-920a80b026dde5eceaa950da92f84240.jpg";